var _path, _rect, _circle, _path2, _path3, _path4, _path5, _mask, _path6, _mask2, _path7, _rect2, _rect3, _circle2, _circle3, _line, _line2, _line3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOnPageScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.001 211C317.501 151.167 349.701 35.3002 266.501 50.5002C162.501 69.5002 15.0007 26 38.0007 147.5C61.0007 269 238.501 396.5 291.001 229",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 98,
    width: 228,
    height: 158,
    rx: 14,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 177,
    r: 42,
    stroke: "#192657",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101 179V132C139.4 132 149 163.333 149 179H101Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266 249.5V116.5C240.5 103.5 261 216.5 219 221.5C180.042 226.137 154.667 235.5 146 249.5H266Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.589 151L189.001 130L173.412 151H182.001V200H195.001V151H204.589Z",
    fill: "#528FF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.589 151L229.001 130L213.412 151H222.001V200H235.001V151H244.589Z",
    fill: "#528FF5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.589 154L183.001 133L167.412 154H176.001V203H189.001V154H198.589Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.001 133L184.606 131.808L183.001 129.645L181.395 131.808L183.001 133ZM198.589 154V156H202.564L200.195 152.808L198.589 154ZM167.412 154L165.806 152.808L163.437 156H167.412V154ZM176.001 154H178.001V152H176.001V154ZM176.001 203H174.001V205H176.001V203ZM189.001 203V205H191.001V203H189.001ZM189.001 154V152H187.001V154H189.001ZM181.395 134.192L196.983 155.192L200.195 152.808L184.606 131.808L181.395 134.192ZM169.018 155.192L184.606 134.192L181.395 131.808L165.806 152.808L169.018 155.192ZM176.001 152H167.412V156H176.001V152ZM178.001 203V154H174.001V203H178.001ZM189.001 201H176.001V205H189.001V201ZM187.001 154V203H191.001V154H187.001ZM198.589 152H189.001V156H198.589V152Z",
    fill: "#192657",
    mask: "url(#path-8-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.589 154L223.001 133L207.412 154H216.001V203H229.001V154H238.589Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.001 133L224.606 131.808L223.001 129.645L221.395 131.808L223.001 133ZM238.589 154V156H242.564L240.195 152.808L238.589 154ZM207.412 154L205.806 152.808L203.437 156H207.412V154ZM216.001 154H218.001V152H216.001V154ZM216.001 203H214.001V205H216.001V203ZM229.001 203V205H231.001V203H229.001ZM229.001 154V152H227.001V154H229.001ZM221.395 134.192L236.983 155.192L240.195 152.808L224.606 131.808L221.395 134.192ZM209.018 155.192L224.606 134.192L221.395 131.808L205.806 152.808L209.018 155.192ZM216.001 152H207.412V156H216.001V152ZM218.001 203V154H214.001V203H218.001ZM229.001 201H216.001V205H229.001V201ZM227.001 154V203H231.001V154H227.001ZM238.589 152H229.001V156H238.589V152Z",
    fill: "#192657",
    mask: "url(#path-10-inside-2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 264,
    width: 234,
    height: 26,
    rx: 13,
    fill: "#528FF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 256,
    width: 240,
    height: 27,
    rx: 13,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.5,
    cy: 218.5,
    r: 15.5,
    fill: "#528FF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 96.5,
    r: 22.5,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 226,
    x2: 248,
    y2: 226,
    stroke: "#192657",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 236,
    x2: 248,
    y2: 236,
    stroke: "#192657",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 246,
    x2: 141,
    y2: 246,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 72,
    width: 10,
    height: 10,
    fill: "#528FF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOnPageScore);
export default __webpack_public_path__ + "static/media/newOnPageScore.7ae76c437ecdb847deb2b595c46e2436.svg";
export { ForwardRef as ReactComponent };